module.exports = __webpack_public_path__ + "static/media/our-story-leaf-3.15d407c2.svg";